export default "__VITE_ASSET__BzEJIf5v__"